var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24124 12.7132C3.11674 12.4975 3.05448 12.3897 3.01963 12.2234C2.99346 12.0985 2.99346 11.9015 3.01963 11.7766C3.05448 11.6103 3.11674 11.5025 3.24124 11.2868C4.27015 9.50484 7.33276 5 12 5C16.6672 5 19.7299 9.50484 20.7588 11.2868C20.8833 11.5025 20.9455 11.6103 20.9804 11.7766C21.0065 11.9015 21.0065 12.0985 20.9804 12.2234C20.9455 12.3897 20.8833 12.4975 20.7588 12.7132C19.7299 14.4952 16.6672 19 12 19C7.33276 19 4.27015 14.4952 3.24124 12.7132Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C13.5148 15 14.7427 13.6569 14.7427 12C14.7427 10.3431 13.5148 9 12 9C10.4852 9 9.25726 10.3431 9.25726 12C9.25726 13.6569 10.4852 15 12 15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.fec3ef8bb5c622667562ee2d4ed24ff6.svg";
export { ForwardRef as ReactComponent };